import { useDropdownState } from '../abstract/dropdown';

export function useBedroomFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { selected: bedroom, onSelect: onBedroomSelect, options: bedroomOptions } = useDropdownState({
    defaultOptions: config.bedroomOptions,
    defaultValue: query.bedroom || config.bedroomDefault,
    filterKey: `beds`,
    setFilters,
    updateQuery,
  });

  return { bedroom, bedroomOptions, onBedroomSelect };
}
